import React from "react";
import { useParams } from "react-router-dom";
import { blogPosts } from "./BlogPost";
import "./BlogPostt.css"; // Import custom styles

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((post) => post.slug === slug);

  if (!post) return <h2>Post not found</h2>;

  return (
    <div className="blog-post-container">
      <h3 className="blog-title">{post.title}</h3>
      <p className="blog-meta">
        <span>{post.date}</span> | <span>{post.author}</span> |{" "}
        <span>{post.category}</span>
      </p>
      <img src={post.image} alt={post.title} className="blog-image" />
      <div
        className="blog-content"
        dangerouslySetInnerHTML={{ __html: post.content }}
      />
    </div>
  );
};

export default BlogPost;
